import React, { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import { closeModal, openAlert } from '../../store/features/modalSlice';
import TextWinds from '../common/TextWinds';
import { IconButton } from '@material-tailwind/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { BoostUpTypes } from '../../constants/types';
import { AppProductListOrderBy, ProductSubType, ProductType } from '../../enum';
import { selectLmsLists } from '../../store/features/lmsSlice';
import instance from '../../api/axios/utils.ts/instance';
import { getErrorMessages } from '../../api/utils/util-func';
import { LoadingSpinner } from '../Loading/LoadingSpinner';

const ModalExtendLink = ({ courseId }: { courseId?: string }) => {
  const lmsLists = useAppSelector(selectLmsLists);

  const targetCourseId = useMemo(() => {
    if (courseId) {
      return courseId;
    } else {
      return lmsLists.course.id;
    }
  }, [courseId, lmsLists]);

  const [boostupLists, setBoostupLists] = useState<BoostUpTypes[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useAppDispatch();

  const params = {
    product_type: ProductType.BOOSTUP,
    product_sub_type: ProductSubType.PRODUCT,
    order_by: AppProductListOrderBy.RECOMMENDED,
    courseId: targetCourseId,
  };

  useEffect(() => {
    if (!targetCourseId) return;

    const fetchBoostupLists = async () => {
      try {
        setIsLoading(true);

        const response = await instance.get('/v1/product', { params });

        const sortedList = [...response.data.result].sort(
          (a, b) =>
            Number(b.product_type === 'COURSE') -
            Number(a.product_type === 'COURSE'),
        );

        setBoostupLists(sortedList);
      } catch (error) {
        dispatch(openAlert({ message: getErrorMessages(error) }));
      } finally {
        setIsLoading(false);
      }
    };

    fetchBoostupLists();
  }, [targetCourseId]);

  const courseProducts = (boostupLists ?? []).filter(
    (product) => product.product_type === 'COURSE',
  );

  const goodProduct = courseProducts.find(
    (product) => product.goods_type === 'GOOD',
  );

  const digitalProduct = courseProducts.find(
    (product) => product.goods_type === 'DIGITAL',
  );

  const closeBtnhandler = () => {
    dispatch(closeModal());
  };

  const navigateBtnHandler = (targetUrl: string) => {
    window.open(targetUrl, '_blank');
    dispatch(closeModal());
  };

  return (
    <div className="mountAnimation mb-40 flex w-[335px] flex-col gap-4 rounded-md bg-white p-4 shadow-card">
      <div className="flex w-full flex-row items-center">
        <div>이용 기간 연장</div>

        <div className="ml-auto flex items-center">
          <IconButton
            variant="text"
            color="blue-gray"
            onClick={closeBtnhandler}
          >
            <XMarkIcon className="!h-[30px] !w-[30px]" />
          </IconButton>
        </div>
      </div>

      {isLoading ? (
        <div className="flex h-[52px] items-center justify-center">
          <span className="text-sm text-gray-500">상품을 불러오는 중...</span>
        </div>
      ) : (
        <div className="grid grid-flow-col-dense gap-2">
          <TextWinds
            type="button2"
            color="purple5"
            className="cursor-pointer rounded-md border p-2 text-center hover:bg-gray2"
            onClick={() => {
              if (!digitalProduct) {
                dispatch(openAlert({ message: '관리자에게 문의해주세요.' }));
                return;
              }
              // option : 구매시 플랜 선택 후 옵션 선택을 띄울지 조건. 옵션은 교재를 추가하는 것.
              // option = false 일 경우 플랜 선택 후 옵션 선택을 띄우지 않음
              navigateBtnHandler(
                `${process.env.REACT_APP_JEBS_APP_URL}/courses/homeschool/details/${digitalProduct.id}` +
                  '?option=false',
              );
            }}
          >
            온라인 연장
          </TextWinds>
          {goodProduct && (
            <TextWinds
              type="button2"
              color="purple5"
              className="cursor-pointer rounded-md border p-2 text-center hover:bg-gray2"
              onClick={() => {
                if (!goodProduct) {
                  dispatch(openAlert({ message: '관리자에게 문의해주세요.' }));
                  return;
                }
                // option : 구매시 플랜 선택 후 옵션 선택을 띄울지 조건. 옵션은 교재를 추가하는 것.
                // option = true 일 경우 플랜 선택 후 옵션 선택을 띄움
                navigateBtnHandler(
                  `${process.env.REACT_APP_JEBS_APP_URL}/courses/homeschool/details/${goodProduct.id}` +
                    '?option=true',
                );
              }}
            >
              교재팩 연장
            </TextWinds>
          )}
        </div>
      )}
    </div>
  );
};

export default ModalExtendLink;
